import Vue from 'vue'
import Main from './main.vue'
import { LEAVE_ROLE } from '@/utils/constUtils'
import { getTeacherTopRole } from '@/utils/comUtils'

const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数
let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const MSchoolAddressDormList = async options => {
  return new Promise(async (resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      role: options.role || LEAVE_ROLE.classTeacher, // 100 老师组
      corpName: options.corpName || '', // 钉钉机构名
      corpId: options.corpId || '', // 钉钉机构Id
      selectedMap: options.selectedMap || {}, // 已选择的值，用于回显
      title: options.title // 要展示的弹框的title
    }

    // 老师角色取优先级
    _options.role = getTeacherTopRole(_options.role)

    // eslint-disable-next-line
    _options.close = function (result) {
      MSchoolAddressDormList.close()
        .then(() => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line
    _options.closeOnly = function () {
      MSchoolAddressDormList.close()
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({
      data: _options
    })
    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    document.body.appendChild(MInstance.dom) // 将dom插入body
    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
MSchoolAddressDormList.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // 销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$address-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

export default MSchoolAddressDormList
